/** Pure placement rules for pointer-reordering Story passages.
 * A visual insertion slot is from 0 (before first row) to length (after last).
 * Removing the dragged row first shifts slots below that row by one. */
export function passageInsertSlot(rects,clientY){
 if(!Array.isArray(rects)||!Number.isFinite(clientY))return 0;
 for(let i=0;i<rects.length;i++){
  const rect=rects[i];
  if(clientY < (rect.top+rect.bottom)/2)return i;
 }
 return rects.length;
}
export function passageReorderTarget(from,slot,length){
 if(!Number.isInteger(from)||!Number.isInteger(slot)||!Number.isInteger(length)||
    from<0||from>=length)return null;
 const bounded=Math.max(0,Math.min(length,slot));
 return Math.max(0,Math.min(length-1,bounded>from?bounded-1:bounded));
}
